export default {
  headerTile: 'Todo lo que necesita saber sobre su viaje',
  contact: 'Contacto',
  noContacts: 'No hay contactos',
  tourResume: 'Resumen del viaje',
  extraField: 'Extras',
  day: 'Día',
  tour: 'Tour',
  flight: 'Vuelo',
  transfer: 'Traslado',
  transportLuggage: 'Transporte de tu equipaje',
  stageNumOriginDestination: 'Etapa: { origin } - { destination }',
  distanceNumberKm: 'Distancia: { number } Km',
  notSelectTransfer: 'Aún no ha seleccionado un traslado',
  notSelectTransport: 'Aún no has seleccionado un transporte',
  accommodation: 'Alojamiento',
  information: 'Información',
  quantityNights: 'Ninguna noche | Una noche | {n} noches',
  totalPrice: 'Precio total',
  whatToDoLocation: 'Qué hacer en { location }',
  urlToLocationMap: 'Url al mapa de { location }',
  urlToLocationWeb: 'Url to { location } website',
  website: 'Sitio web',
  map: 'Mapa',
  linkAboutDay: 'Enlace sobre el día',
  guidebookLocation: 'Guía: { location }',
  viewWebsite: 'Ver sitio web',
  viewGoogleMaps: 'Ver en Google Maps',
  stageInformation: 'Información de la etapa',
  dayInformation: 'Información del día',
  guidebookOfLocation: 'Guía de { location }',
  linkGoogleMapsResource: 'Enlace a Google Maps de { resource }',
  linkResourceWebsite: 'Enlace al sitio web de { resource }',
  address: 'Dirección',
  noResourcesLocation: 'No se han añadido recursos a esta ubicación',
  viewWebsiteOfSupplier: 'Ver el sitio web de { supplier }',
  urlGoogleMapsOfSupplier: 'Url a Google Maps de { supplier }',
  travelInformation: 'Información de tu viaje',
  pricePerPerson: 'Precio por persona',
  downloadErrorText: 'Ha ocurrido un error al descargar',
  pricePerUnit: '€/unidad',
  printTravelBook: 'Descargar PDF',
  downloadPdf: 'Descargar PDF',
  preferNotPrintTitle: '🌿 ¡No necesitas imprimirlo!',
  preferNotPrintIntro: 'Ayúdanos a cuidar el medio ambiente y lleva tu documento de viaje en tu teléfono o tablet. 📱🥾',
  preferNotPrintOfficial: 'La versión online es tu documento oficial y está siempre actualizada. Cualquier cambio se actualiza inmediatamente, para que siempre tengas la información más reciente a mano. ✔️',
  preferNotPrintFooter: 'Menos papel, más comodidad: ¡todo lo que necesitas, en tu bolsillo! 🌍💚',
  stayDigital: 'Seguir en digital',
  downloadPdfAnyway: 'Descargar igual',
  preparedFor: 'Preparado Para',
  reference: 'Referencia',
  beforeTrip: 'Antes de Su Viaje',
  luggage: 'Transporte de tu equipaje',
  emergenciesInSpain: 'Emergencias en España',
  afterTrip: 'Información Post Viaje',
  supportContacts: 'Soporte y Contactos',
  needToKnow: 'Lo esencial',
  inclusionsExclusions: 'Qué Incluye y Qué No',
  whatsIncluded: 'Qué Incluye',
  whatsNotIncluded: 'Qué No Incluye',
  optionalExtras: 'Extras Opcionales',
  readyToAdventure: '¿Listo para la Aventura?',
  finalizeReservation: 'Finalice su reserva y asegure su itinerario personalizado hoy.',
  whatsappSpecialist: 'Especialista por WhatsApp',
  requestReservation: 'Solicitar Reserva',
  itineraryNotFound: 'Itinerario No Encontrado',
  itineraryNotFoundDescription: 'No pudimos recuperar este itinerario. Puede haber expirado o el enlace no es válido.',
  returnHome: 'Volver al Inicio',
  featuredImage: 'Imagen Destacada del Viaje',
  displayMode: 'Modo de visualización',
  colorMode: 'Color',
  darkMode: 'Oscuro',
  km: 'km',
  service: 'Servicio',
  services: 'Servicios',
  viewMore: 'Ver Más',
  viewLess: 'Ver Menos',
  stayContinues: 'La estancia continúa',
  hotel: 'Alojamiento',
  refuge: 'Refugio',
  hotelOptions: 'Opciones de alojamiento',
  selectHotel: 'Elige un hotel',
  activityPreviewNote: 'Vista previa de la actividad. Así verá el cliente el cuaderno de viaje, sin datos del cliente ni habitaciones.',
  noServicesThisDay: 'No hay servicios este día',
  restaurant: 'Restaurante',
  activity: 'Actividad',
  transport: 'Transporte',
  general_information: 'Información General',
  stage_information: 'Información de la Etapa',
  files: 'Archivos',
  openFile: 'Abrir archivo',
  downloadFile: 'Descargar',
};
